import './styles.scss';
import { initAuthToken } from "./core/hooks/useSession";
import { Routes } from './Routes';


// global init
initAuthToken();

export function App() {

  return (
	<div className="app">

		<Routes />

	</div>
  );
}
